export default __webpack_public_path__ + "static/TarotHover-c9201ee3400beea579f74a7034f71a85.png";